<template>
  <div class="bg-white p-4" id="quoteGen">
    <div class="flex items-center py-4 px-0 font-semibold">

      <img src="@/assets/images/icons/back-icon.svg"
        @click="$router.push({ name: 'EarningAndPayout', query: { tab: 'earnings' } })" class="mr-4 cursor-pointer" />
      Batch Summary
    </div>

    <p class="currentDateTime">
      {{ currentDateTime }}
    </p>

    <div class="title-container flex-wrap mb-4">
      <div class="flex items-center gap-2">
        <div> <img src="@/assets/images/billing/batch_id.svg" /> </div>
       
        <p class=""> <span>Shipping ID #</span><br>
          <!-- {{
            transaction.shipping ? transaction.shipping.shippingReference : "N/A"
          }} -->
             {{
            transaction.batchId
          }}
          </p>
      </div>

      <div class="flex items-center gap-2">
        <div> <img src="@/assets/images/billing/t_revenue.svg" /> </div>
       
        <p class=""> <span>Total Revenue</span><br>
          {{
            transaction.totalRevenue
          }}</p>
      </div>

      <div class="flex items-center gap-2">
        <div> <img src="@/assets/images/billing/t_earnings.svg" /> </div>
        <p class=""> <span>Total Earnings</span><br>{{Number(transaction.totalEarnings.toFixed(2))}}</p>
      </div>
    </div>

    <div class="Trip-Summary-container  w-full mb-4">
      <span  class="Trip-Summary mb-2">Trip Summary</span>
      <div class="flex justify-between mb-2">
        <p class="flex-1">Door-to-Door ({{transaction.totalPickups}} Pick up and {{transaction.totalDeliveries}} Deliveries)</p>
        <p class="flex-1">Distance Covered ({{transaction.distance}})</p>
        <p class="flex-1">Active Time ({{transaction.activeTime}})</p>
      </div>
      <div class="px-3 pt-2">
        <div class="flex ">
          <div class="Shipment-container senders-container flex-1 mr-4 pr-4">
            <h2 class="mb-2">Senders</h2>
            <div>
              <div v-for="sender in senders" :key="sender">
                <p>{{sender.schedule}}</p>
                <div class="flex gap-2 items-center">
                  <p>{{sender.time}}</p>
                  <div class="divider"></div>
                  <p>{{sender.route}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class=""></div>
          <div class="Shipment-container flex-1">
            <h2 class="mb-2">Receivers</h2>
            <div>
              <div v-for="receiver in receivers" :key="receiver">
                <p>{{receiver.schedule}}</p>
                <div class="flex gap-2 items-center">
                  <p>{{receiver.time}}</p>
                  <div class="divider"></div>
                  <p>{{receiver.route}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>

    <div class="Earning-Summary-container">
      <div class="flex gap-6">
        <div class="flex-1">
          <span class="Earning-Summary ">Earning Summary</span>
          <div class="batch-cover flex justify-between mt-2">
            <p>Batch Pay</p>
            <span>{{transaction.batchPay}}</span>
          </div>
          <hr>
          <div class="tips-cover flex justify-between">
            <p class="tips">Tips</p>
            <span>{{transaction.tips}}</span>
          </div>
          
          <div class="batch-cover flex justify-between mt-2" v-for="tip in listTips" :key="tip">
            <!-- <p>{{sender.schedule.split(" ").slice(0, 2).join(" ")}}</p> -->
            <p>{{tip.name}}</p>
            <span>{{tip.tips}}</span>
          </div>
        </div>
         <div class="divider-one "></div>
        <div class="flex-1">
          <div class="bg-white rounded-xl py-4">
             <div class="flex justify-center w-full "> <img src="@/assets/images/billing/palm.svg" /> </div>
            <p class="text-center mt-2 mb-2 sender-tipped" v-for="tip in listTips" :key="tip">{{tip.name}} tipped <span>{{transaction.tips}}</span></p>
            <div class="flex justify-center w-full"> <button class="px-6 py-2">Say Thank You</button> </div>
          </div>
        </div>
      </div>
    </div>

    <div class="Earning-Summary-container mt-4">
      <div class="">
        <div>
           <div class="tips-cover flex justify-between">
            <p class="tips">Total Revenue</p>
            <span>{{transaction.totalRevenue}}</span>
          </div>    
          <div class="batch-cover flex justify-between mt-2" v-for="rev in revenue" :key="rev">
            <p>{{rev.name}}</p>
            <span>{{rev.price}}</span>
          </div>
          <hr>
           <div class="tips-cover flex justify-between">
            <p class="tips">Total Earnings</p>
            <span>{{Number(transaction.totalEarnings.toFixed(2))}}</span>
          </div> 
        </div>
      </div>
    </div>

  
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import moment from "moment";

export default {
  data() {
    return {
      timeline: [],
      senders: [],
      receivers: [],
      listTips: [],
      currentDateTime: moment().format("dddd, MMM D, YYYY, h:mma"),
      transactionId: this.$route.params.id,
      transaction: {},
       revenue: [],
    };
  },
  mounted() {
    this.getReciept();
  },
  computed: {
    stringDate() {
      let dateString = this.transaction?.createdAt || "";
      return (
        moment.utc(dateString).local().format("DD MMMM YYYY, HH:mm") || "--"
      );
    },
    transactionHeader() {
      let header = "";
      switch (this.type) {
        case "quote":
          header = " Estimates";
          break;
        case "recievable":
          header = " Receivables";
          break;
        default:
          header = "  Collections (Shipment Receipt)";
          break;
      }
      return header;
    },
    type() {
      return localStorage.getItem("billing_reciept");
    },
    discription() {
      if (!this.transaction?.shipping?.packagees.length) return "";
      return this.transaction?.shipping?.packagees
        .map((item) => (item?.description ? item?.description + ", " : ""))
        .reduce((prev, next) => prev + next);
    },
    totalWeight() {
      if (!this.transaction?.shipping?.packagees.length) return 0;
      return this.transaction.shipping.packagees
        .map((item) => item.estimatedWeight)
        .reduce((prev, next) => prev + next);
    },
  },
  methods: {
    formatTime(timestamp) {
      return moment(timestamp).format("hh:mm A");
    },

    hasTrip(val) {
      return val?.shipping?.tripId;
    },
    // organizationName(shipping) {
    //   return shipping ? "hs" : "hs";
    // },
    returnStringDate(dateString) {
      return moment(dateString).format("DD/MM/YYYY, HH:mm") || "--";
    },
    generateQuote() {
      try {
        var element = document.getElementById("quoteGen");
        html2pdf(element);
      } catch (e) {
        // ...any code here
      }
    },
    async getReciept() {
      try {
        // let response = await this.$_getReciept(this.transactionId);
        let response = await this.$_getBatchmentSummary(this.transactionId, { customerType: '3PL'});
        this.transaction = response.data.data.batchSummary;
        this.revenue = [
          { name: "Batch Pay:", price: this.transaction.batchPay },
          { name: "Tips:", price: this.transaction.tips },
          { name: "Commission Rate:", price: this.transaction.commissionRate },
          { name: "Payment Method:", price: this.transaction.paymentMethod }
        ];
        this.listTips = this.transaction.listTips;
        const timeline = response.data.data.timeline;
      
        this.senders = timeline
          .filter(item => item.type === "pick_up")
          .map(item => ({
            schedule: item.name,
            time: this.formatTime(item.timestamp),
            route: item.address
          }));

        this.receivers = timeline
          .filter(item => item.type === "delivery")
          .map(item => ({
            schedule: item.name,
            time: this.formatTime(item.timestamp),
            route: item.address
          }));
         
        // this.transaction = response.data.data.transaction;
        console.log("---transaction", this.transaction);
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.currentDateTime {
  color: #10233E;
  font-weight: 700;
  font-size: 12px;
  margin-bottom: 2%;
}
.Trip-Summary-container>.Trip-Summary{
  @apply font-bold text-[12px] text-[#10233E];
}

.Trip-Summary-container {
   @apply  bg-[#F2F7FC] py-4 px-6 rounded-xl;
}
.Earning-Summary-container{
  @apply  bg-[#F2F7FC] py-4 px-6 rounded-xl;
}
.Earning-Summary, .tips {
@apply font-bold text-[12px] text-[#10233E];
}

.title-container {
  @apply flex bg-[#F2F7FC] py-4 px-6 justify-between rounded-md;
}
.Trip-Summary-container >div> p{
  color: #383F51;
  font-weight: 600;
  font-size: 12px;
}
.title-container >div> p{
  // width: 70%;
  color: #383F51;
  font-weight: 600;
  font-size: 16px;
}

.title-container >div> p>span{
  color: #7A90A7;
  font-weight: 700;
  font-size: 12px;
}
.Shipment-container{
  // border: 1px solid red;
}
.senders-container{
  border-right: 1px solid #4142453D;
}
.batch-cover>p{
  font-size: 12px;
  font-weight: 600;
  color: #7A90A7;
}
.batch-cover>span, .tips-cover>span{
  font-size: 13px;
  font-weight: 600;
  color: #10233E;
}
.Shipment-container>div>div{
  // border: 1px solid blue;
  display: flex;
  justify-content: space-between;
  margin-bottom: 2%;
}
.Shipment-container>div>div>p{
  color: #7A90A7;
  font-weight: 600;
  font-size: 12px;
}
.Shipment-container>div>div>div>p{
  color: #10233E;
  font-weight: 400;
  font-size: 13px;
}
.Shipment-container > h2{
 color: #10233E;
  font-weight: 600;
  font-size: 16px;
}

.divider {
  width: 1px;
  height: 15px;
  background: #4142453D;
}
.divider-one {
  width: 1px;
  height: 162px;
  background: #4142453D;
}
hr{
  border: 0.5px solid #4142453D;
  margin: 2% auto;
}
.sender-tipped>span{
  color: #09B78A;
  font-size: 13px;
  font-weight: 600;
}
button{
  background-color: #10233E;
  border-radius: 8px;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 600;
}

.ship-content {
  li {
    @apply pt-2;
  }
}

.detail-container {
  @apply bg-gray-100 rounded-md;
  width: 100%;
}

.detail-list {
  li {
    @apply py-2 opacity-50 flex items-start;

    span:nth-of-type(1) {
      @apply inline-block mr-2;
    }

    span:nth-of-type(2) {
      @apply inline-block text-right;
    }
  }
}

td {
  @apply pl-0;
}

th {
  @apply pb-2;
}

tr {
  @apply border-gray-200;
  border-bottom-width: 2px;
}

.slide-table {
  width: 100%;
  min-width: 700px;
}
</style>